export default{
    ALTER_API_DECODE: (state, url) => {
        state.api_decode = url
    },
    ALTER_API_AUTHENTICATION: (state, url) => {
        state.api_authentication = url
    },
    ALTER_HOST_AUTHENTICATION: (state, url) => {
        state.host_authentication = url
    },
    ALTER_FIREBASE_CONFIG_GAME: (state, config) => {
        state.firebase_config_game = config
    },
    ALTER_FIREBASE_CONFIG_CHAT: (state, config) => {
        state.firebase_config_chat = config
    }
}